import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useBreakpoint } from "@brg/ui";
import { getChat } from '../reducers/chatReducer';
import { SCROLL_POSITION } from '../components/desktopApp/comments/const/const';
import { onUpdateScroll } from '../actions/chatActions';
export var useScrollByMsg = function (scrollPosition, canScrollOnAnyBlock) {
    var dispatch = useDispatch();
    var _a = useState(Date.now()), time = _a[0], setTime = _a[1];
    var _b = useState(null), scrollElement = _b[0], setScrollElement = _b[1];
    var _c = useSelector(function (store) { return getChat(store); }), scrollId = _c.scrollId, isScrolling = _c.isScrolling;
    var onSetScrolling = function (flag) {
        dispatch(onUpdateScroll(flag));
    };
    var getElement = useCallback(function (postId, maxAttempts, attemptInterval) {
        if (maxAttempts === void 0) { maxAttempts = 3; }
        if (attemptInterval === void 0) { attemptInterval = 1000; }
        var element = document.querySelector("[data-message-id=\"".concat(postId, "\"]"));
        if (!element && maxAttempts > 1) {
            setTimeout(function () { return getElement(postId, maxAttempts - 1, attemptInterval); }, attemptInterval);
        }
        else {
            setTime(Date.now());
            setScrollElement(element);
        }
    }, [scrollId]);
    useEffect(function () {
        if (scrollId) {
            getElement(scrollId);
        }
    }, [canScrollOnAnyBlock, getElement]);
    useEffect(function () {
        if (!!scrollElement) {
            onSetScrolling(true);
            setTimeout(function () {
                if (scrollPosition === SCROLL_POSITION.start) {
                    var yOffset = -70;
                    var y = scrollElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                    return;
                }
                scrollElement.scrollIntoView({ behavior: "smooth", block: scrollPosition || "center", inline: scrollPosition || "start" });
                onSetScrolling(false);
            }, 200);
        }
    }, [scrollElement, time, scrollPosition]);
    return [];
};
//# sourceMappingURL=useScrollByMsg.js.mapimport React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useBreakpoint } from "@brg/ui";
import { getChat } from '../reducers/chatReducer';
import { SCROLL_POSITION } from '../components/desktopApp/comments/const/const';
import { onUpdateScroll } from '../actions/chatActions';
export var useScrollByMsg = function (scrollPosition, canScrollOnAnyBlock) {
    var dispatch = useDispatch();
    var _a = useState(Date.now()), time = _a[0], setTime = _a[1];
    var _b = useState(null), scrollElement = _b[0], setScrollElement = _b[1];
    var _c = useSelector(function (store) { return getChat(store); }), scrollId = _c.scrollId, isScrolling = _c.isScrolling;
    var onSetScrolling = function (flag) {
        dispatch(onUpdateScroll(flag));
    };
    var getElement = useCallback(function (postId, maxAttempts, attemptInterval) {
        if (maxAttempts === void 0) { maxAttempts = 3; }
        if (attemptInterval === void 0) { attemptInterval = 1000; }
        var element = document.querySelector("[data-message-id=\"".concat(postId, "\"]"));
        if (!element && maxAttempts > 1) {
            setTimeout(function () { return getElement(postId, maxAttempts - 1, attemptInterval); }, attemptInterval);
        }
        else {
            setTime(Date.now());
            setScrollElement(element);
        }
    }, [scrollId]);
    useEffect(function () {
        if (scrollId) {
            getElement(scrollId);
        }
    }, [canScrollOnAnyBlock, getElement]);
    useEffect(function () {
        if (!!scrollElement) {
            onSetScrolling(true);
            setTimeout(function () {
                if (scrollPosition === SCROLL_POSITION.start) {
                    var yOffset = -70;
                    var y = scrollElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                    return;
                }
                scrollElement.scrollIntoView({ behavior: "smooth", block: scrollPosition || "center", inline: scrollPosition || "start" });
                onSetScrolling(false);
            }, 200);
        }
    }, [scrollElement, time, scrollPosition]);
    return [];
};
//# sourceMappingURL=useScrollByMsg.js.map